/**
 * Created by 李伟 on 2018/1/25.
 * 用户信息
 */
import { post, post2 } from 'utils/post';

//获取店铺首页数据
export function getStoreIndexDetail(data) {
  return post2('/pc/store/index', data)
}
//获取店铺全部商品数据
export function getStoreGoodList(data) {
  return post2('/pc/store/tag', data)
}
//获取店铺详情数据
export function getStoreDetail(data) {
  return post2('/pc/store/detail', data)
}
//获取店铺实体图片数据
export function getStoreImgs(data) {
  return post2('/pc/store/img', data)
}
//店铺收藏
export function addStoreCollections(data) {
  return post2('/api/collection/save', data)
}
//店铺商品类型
// export function getNavigationTag(data) {
//   return post('/api/goods/zyCategoryV2', data)
// }




// WEBPACK FOOTER //
// ./src/api/shop.js